<template>
  <LoadingScreen />
  <Alerta />
  <RouterView />
  <CookieConsent />
</template>

<script setup>
import { inject, onMounted } from 'vue'
import { useStoreAlerta } from './stores/alerta'
import Alerta from '@/components/global/alerta/Alerta.vue'
import LoadingScreen from '@/components/global/loading/LoadingScreen.vue'
import CookieConsent from '@/components/global/cookie/CookieConsent.vue'
import { useLoadingStore } from '@/stores/loading'

const emitter = inject("emitter")
const storeAlerta = useStoreAlerta()
const loadingStore = useLoadingStore()

function mostrarAlerta(payload) {
  const dados = {
    visivel: true,
    mensagem: payload.mensagem,
    classe: payload.classe
  }
  storeAlerta.mostrarAlerta(dados)
}

onMounted(() => {
  emitter.on('mostrarAlerta', (payload) => mostrarAlerta(payload))
  // loadingStore.showFor(3000) // Removido loading forçado para debug
})
</script>
